"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  en: {
    date: 'ddd, MMM D, YYYY',
    time: 'h:mm A',
    hours: 'h',
    minutes: ':mm',
    month: 'MMMM YYYY',
    period: 'A',
    weekday: 'dd',
    flightInfo: 'D MMM YYYY',
    today: 'Today',
    accept: 'Accept'
  },
  es: {
    date: 'ddd, D [de] MMM [de] YYYY',
    time: 'H:mm',
    hours: 'H',
    minutes: ':mm',
    month: 'MMMM YYYY',
    period: '[]',
    weekday: 'dd',
    today: 'Hoy',
    accept: 'Aceptar'
  }
};
exports["default"] = _default;